<template>
    <Stub />
</template>

<script>
import Stub from '@/components/common/Stub';

export default {
    name: 'HelpPage',
    components: {
        Stub,
    },
};
</script>
